import type { FC, ReactNode } from "react";

import type { ButtonType } from "@similarweb/ui-components";
import { Button, ButtonLabel } from "@similarweb/ui-components";

import { ButtonGroup } from "../../ButtonsGroup/src/ButtonsGroup";
import { ProModal } from "../src/ProModal";

export interface IConfirmationModalProps {
    isOpen: boolean;
    onCancelClick: () => void;
    onApproveClick: () => void;
    cancelButtonText: string;
    approveButtonText: string;
    onCloseClick?: () => void;
    approveButtonIsLoading?: boolean;
    approveButtonIsDisabled?: boolean;
    extraComponent?: React.ReactNode;
    approveButtonType?: ButtonType;
    cancelButtonType?: ButtonType;
    width?: string;
    showCloseIcon?: boolean;
    children?: ReactNode;
}

export const ConfirmationModal: FC<IConfirmationModalProps> = ({
    isOpen,
    onCloseClick,
    onApproveClick,
    approveButtonText,
    approveButtonIsLoading = false,
    approveButtonIsDisabled = false,
    onCancelClick,
    cancelButtonText,
    approveButtonType = "flatWarning",
    cancelButtonType = "flat",
    width = "518px",
    showCloseIcon = true,
    children,
}) => {
    const moreProps: any = {
        customStyles: {
            content: {
                boxSizing: "content-box",
                width: width,
            },
        },
    };
    return (
        <div>
            <ProModal
                isOpen={isOpen}
                onCloseClick={onCloseClick}
                showCloseIcon={showCloseIcon}
                {...moreProps}
            >
                <div>
                    {children}
                    <ButtonGroup>
                        <Button
                            type={cancelButtonType}
                            onClick={onCancelClick}
                        >
                            <ButtonLabel>{cancelButtonText}</ButtonLabel>
                        </Button>
                        <Button
                            type={approveButtonType}
                            onClick={onApproveClick}
                            isLoading={approveButtonIsLoading}
                            isDisabled={approveButtonIsDisabled}
                        >
                            <ButtonLabel>{approveButtonText}</ButtonLabel>
                        </Button>
                    </ButtonGroup>
                </div>
            </ProModal>
        </div>
    );
};
ConfirmationModal.displayName = "ConfirmationModal";
